import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import {
  CATEGORY_LIST,
  CATEGORY_LIST_FOR_COUPON,
} from "../actions/category.actions.types";
import { categorySlice } from "../slices/category";

const call = Effects.call;

function* getCategoryList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "categories/list",
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(
        categorySlice.actions.setCategoryList(result.data?.categories)
      );
      callback({ success: true, data: result.data });
    }
  }
}

function* categoryListForCoupon({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "categories/list-for-coupon",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* Category() {
  yield all([takeLatest(CATEGORY_LIST, getCategoryList)]);
  yield all([takeLatest(CATEGORY_LIST_FOR_COUPON, categoryListForCoupon)]);
}

export default Category;
